export const uk = {
    'audio-title': 'Бібліотека аудіороликів'
};
